import { object, string, TypeOf } from 'zod';

import { customErrorMap } from './registration';

/* ---------------------------- LoginRequestBody ---------------------------- */

export const LoginRequestBody = object({
    email: string({ errorMap: customErrorMap }).email(),
    password: string({ errorMap: customErrorMap }),
});
export type LoginRequestBody = TypeOf<typeof LoginRequestBody>;

/* ------------------------------ LoginResponse ----------------------------- */

export const LoginResponse = object({
    refreshToken: string(),
});
export type LoginResponse = TypeOf<typeof LoginResponse>;
